import { getDb } from '../db';
import type { CalibrationRun } from '../../core/types';

/**
 * Zielübung runs (§5.6). Kept indefinitely: this is the only record of how this
 * person's functional access changes over time, and it is the closest thing we will
 * have to hand a clinician if access ever opens up.
 */
export const calibrationRepo = {
  async all(): Promise<CalibrationRun[]> {
    const db = await getDb();
    return db.getAllFromIndex('calibration', 'byRanAt');
  },

  async latest(): Promise<CalibrationRun | undefined> {
    const runs = await this.all();
    return runs.at(-1);
  },

  async upsert(run: CalibrationRun): Promise<void> {
    const db = await getDb();
    await db.put('calibration', run);
  },

  async bulkPut(runs: readonly CalibrationRun[]): Promise<void> {
    const db = await getDb();
    const tx = db.transaction('calibration', 'readwrite');
    await Promise.all(runs.map((run) => tx.store.put(run)));
    await tx.done;
  },
};
